import { useTranslationInterface } from 'utils/hooks/useTranslation';

export const useGoalsTranslations = () => useTranslationInterface('iterableGoals');
